export const getEnrolments = (state) => state.enrolment.enrolmentList;
export const getEnrolmentDetails = (state) => state.enrolment.enrolmentDetails;
